import { render, staticRenderFns } from "./Points_List.vue?vue&type=template&id=8a78bb70&"
import script from "./Points_List.vue?vue&type=script&lang=js&"
export * from "./Points_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports